export default __webpack_public_path__ + "static/media/ms.5114c3f7.svg";